/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ComboBoxController", ["ValueContainerControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class ComboBoxController
   * @memberOf classes
   * @extends classes.ValueContainerControllerBase
   */
  class ComboBoxController extends cls.ValueContainerControllerBase /** @lends classes.ComboBoxController.prototype */ {
    static __name = "ComboBoxController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.DialogTypeVMBehavior);
      if (this.isInTable()) {
        this._addBehavior(cls.TableSizeVMBehavior);
      }
      if (!this.isInTable() || this.isInFirstTableRow()) {
        this._addBehavior(cls.LayoutInfoVMBehavior);
      }
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // pseudo-selector behaviors
      this._addBehavior(cls.ActivePseudoSelectorBehavior);
      this._addBehavior(cls.DialogTypePseudoSelectorBehavior);
      if (this.isInMatrix()) {
        this._addBehavior(cls.MatrixCurrentRowVMBehavior);
      }
      // 4st behaviors
      this._addBehavior(cls.FontStyle4STBehavior);
      this._addBehavior(cls.FontSize4STBehavior);
      this._addBehavior(cls.FontColor4STBehavior);
      this._addBehavior(cls.Border4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);
      this._addBehavior(cls.DefaultTTFColor4STBehavior);
      // vm behaviors
      this._addBehavior(cls.EnabledVMBehavior);
      this._addBehavior(cls.HiddenVMBehavior);
      this._addBehavior(cls.ColorVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
      this._addBehavior(cls.FontWeightVMBehavior);
      this._addBehavior(cls.FontFamilyVMBehavior);
      this._addBehavior(cls.TextTransformVMBehavior);
      this._addBehavior(cls.TextDecorationVMBehavior);
      // QueryEditableVMBehavior must be executed before ItemVMBehavior & ValueVMBehavior
      // in order to set value default value on proper widget
      this._addBehavior(cls.QueryEditableVMBehavior);
      this._addBehavior(cls.ItemVMBehavior);
      this._addBehavior(cls.ValueVMBehavior);
      this._addBehavior(cls.TitleVMBehavior);
      this._addBehavior(cls.MaxLengthVMBehavior);
      this._addBehavior(cls.PlaceholderVMBehavior);
      this._addBehavior(cls.CursorsVMBehavior);
      this._addBehavior(cls.StretchVMBehavior);

      //Field Validation
      this._addBehavior(cls.NotNullVMBehavior);
      this._addBehavior(cls.RequiredVMBehavior);
      this._addBehavior(cls.IncludeVMBehavior);

      // ui behaviors
      this._addBehavior(cls.ValueChangedUIBehavior);
      this._addBehavior(cls.RequestFocusUIBehavior);
      this._addBehavior(cls.OpenDropDownUIBehavior);
      if (this.isInTable()) {
        this._addBehavior(cls.TableImageVMBehavior);
        this._addBehavior(cls.RowSelectionUIBehavior);
        this._addBehavior(cls.TableItemCurrentRowVMBehavior);
      }
    }
  }

  cls.ComboBoxController = ComboBoxController;
  cls.ControllerFactory.register("ComboBox", cls.ComboBoxController);
});
